module.exports = __webpack_public_path__ + "img/headphones.222f361e.svg";